import { makePlanLongId } from ".";
import {
  UserLanguage,
  FullPlanId,
  MctToastType,
  PlanDetailsSection,
} from "../@types";
import routes from "../app/routes";
import URI from "urijs";

const makeFullUrl = (
  baseRoute: string,
  language: UserLanguage,
  year: string,
  section: string
): string => {
  return `${baseRoute}?year=${year}&lang=${language}#${section}`;
};

export const getPlanDetailsStarRatingsRoute = (
  plan: FullPlanId,
  language: UserLanguage,
  year: string
): string => {
  return makeFullUrl(
    routes.planDetails.replace(":id", makePlanLongId(plan)),
    language,
    year,
    PlanDetailsSection.STAR_RATINGS
  );
};

export const getToastRoute = (
  currentRoute: string,
  toastType: MctToastType
): string => {
  const curr = new URI(currentRoute);
  curr.addQuery("mctt", toastType);

  return curr.toString();
};

export const getRedirectForMedigapOrPlanFinder = (url: URL): string | null => {
  let redirectUrl = null;

  const medigapPath = "medigap-supplemental-insurance-plans";
  const planComparePath = "plan-compare";

  const medigapRoutes = Object.values(routes.medigap).map(route => {
    const matches = route.match(/m\/(.*?)\//);
    const value = matches ? `/m/${matches[1]}` : route;

    return value;
  });

  const planCompareRoutes = Object.values(routes)
    .filter((r): r is string => typeof r === "string")
    .map(route => route.replace("/:id", ""));

  const { pathname, hash } = url;

  // Remove the #, query string, and additional "/" after m/route
  let formattedHash = hash.replace("#", "").replace(/\?.+/gm, "");

  const matches = formattedHash.match(/m\/(.*?)\//);
  formattedHash = matches ? `/m/${matches[1]}` : formattedHash;

  const strippedPath = pathname.replace(/\//gm, "");

  if (
    strippedPath === medigapPath &&
    planCompareRoutes.includes(formattedHash)
  ) {
    redirectUrl = `${url.origin}/${planComparePath}/${url.hash}`;
  } else if (
    strippedPath === planComparePath &&
    medigapRoutes.includes(formattedHash)
  ) {
    redirectUrl = `${url.origin}/${medigapPath}/${url.hash}`;
  } else if (
    strippedPath === medigapPath &&
    !medigapRoutes.includes(formattedHash)
  ) {
    redirectUrl = `${url.origin}/${medigapPath}/#/m`;
  }

  return redirectUrl;
};
